import { Injectable } from '@angular/core';
import { FormControl, FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';


@Injectable()
export class DatatableFiltersUtil {
  rangeFilterPojo: NumericFieldFilters;
  range: Array<NumericFieldFilters>;

  constructor(public formBuilder: FormBuilder, private datePipe: DatePipe) {
  }

  initializeRangeFilterFormGroup() {
    return this.formBuilder.group({
      columnname: new FormControl(),
      action: new FormControl(),
      value1: new FormControl(),
      value2: new FormControl(),
    });
  }

  getNewRange(filtertype, column, range, rangefilterformgrp) {
    this.range = range;
    //Initialising pojo 
    this.rangeFilterPojo = new NumericFieldFilters();
    // checking for duplicates filters for this respective column
    this.range = this.deleteColumnFromCurrentRange(column, this.range);
    // setting the form control values to a POJO
    if (filtertype === 'rangefilter') {
      this.rangeFilterPojo.columnname = column.toLowerCase();
      this.rangeFilterPojo.action = rangefilterformgrp.action;
      this.rangeFilterPojo.value1 = rangefilterformgrp.value1;
      this.rangeFilterPojo.value2 = rangefilterformgrp.value2;
    }
    else if (filtertype === 'greaterthan' || filtertype === 'lessthan') {
      this.rangeFilterPojo.columnname = column.toLowerCase();
      this.rangeFilterPojo.action = rangefilterformgrp.action;
      this.rangeFilterPojo.value1 = rangefilterformgrp.value1;
    }
    // Setting range
    this.range.push(this.rangeFilterPojo);
    // Returns Range
    return this.range;
  }

  deleteColumnFromCurrentRange(column, range) {
    if (range.length > 0) {
      range.forEach(element => {
        if (column.toLowerCase() === element.columnname) {
          range.splice(range.findIndex(element => column.toLowerCase() === element.columnname), 1)
        }
      });
    }
    return range;
  }

  getNewTextSearchList(searchedValues, search) {
    for (let i = 0; i < searchedValues.length; i++) {
      const key = Object.keys(searchedValues[i])[0];
      const value = searchedValues[i][key];
      search[key] = value;
    }
    return search;
  }

  getNewFilterList(filteredValues, filter) {
    for (let i = 0; i < filteredValues.length; i++) {
      const key = Object.keys(filteredValues[i])[0];
      const value = filteredValues[i][key];
      filter[key] = value;
    }
    return filter;
  }

  getTextFilterOptionsByColumn(column, moduledata) {
    moduledata = moduledata.filter(a => a.filtertype.toLowerCase() === column.toLowerCase())
    let options = [];
    moduledata.forEach(element => { options.push(element.filtervalue); });
    return options;
  }

  // addToTextFiltersList(filteredValues, event, column) {
  //   var selectedVal;
  //   const colname = column.toString().toLowerCase();
  //   selectedVal = event;
  //   if (selectedVal) {
  //     if (filteredValues && filteredValues != null && filteredValues != undefined && filteredValues != [] && filteredValues.length != 0) {
  //       selectedVal = selectedVal.join('|');
  //     }
  //     const filteredKeyPair = {};
  //     filteredKeyPair[colname] = selectedVal;
  //     filteredValues.push(filteredKeyPair);
  //   }
  //   return filteredValues;
  // }

  addToTextFiltersList(filteredValues, event, column) {
    let selectedVal; const colname = column.toString().toLowerCase()
    selectedVal = event;

    if (selectedVal) {
      selectedVal = selectedVal.join('|');
      const filteredKeyPair = {};
      filteredKeyPair[colname] = selectedVal;
      filteredValues.push(filteredKeyPair);
    }
    return filteredValues;
  }

  getEventtobeSetonEachFilteritems(databasedonColumn, cols, event) {
    let eventtobeset;
    if (databasedonColumn.length > 0) {

      let existingfieldRemoval = databasedonColumn.find(a => a.value.length > event.length)
      if (existingfieldRemoval) {
        eventtobeset = { column: cols, value: event, type: 'removal' }
      }
      else {
        let existingfieldAddition = databasedonColumn.filter(a => a.value.length <= event.length)
        let values = existingfieldAddition.map(function (i) {
          return i.value;
        });
        var result
        values.forEach(element => {
          result = event.filter(e => !element.find(a => e.includes(a)))
        })
        eventtobeset = { column: cols, value: event, type: 'add', currentvalue: result }
      }
    }
    else {
      eventtobeset = { column: cols, value: event, type: 'add' }
    }
    return eventtobeset;
  }
  getDataforFilterbasedOnFiltersApplied(currentResponsedata, totalfilteredValue, curtotalfilteredValue, currentFilteredValue, existingdata) {

    let filtersMasterData;
    //Not Sequential & During Addition of fields in filters
    if (totalfilteredValue.length > 0 && totalfilteredValue.length != curtotalfilteredValue.length && currentFilteredValue.type === 'add') {

      var datatobeadded
      const compareAll = (obj1, obj2) => {
        return (obj1.filtervalue === obj2.filtervalue && obj1.filtertype === obj2.filtertype);
      }
      let output = currentResponsedata.filter(b => {
        let indexFound = existingdata.findIndex(a => compareAll(a, b));
        return indexFound == -1;
      })
      datatobeadded = existingdata.concat(output);
      filtersMasterData = datatobeadded;
    }
    //Not Sequential & During Removal of fields in filters
    else
      if (totalfilteredValue.length > 0 && totalfilteredValue.length != curtotalfilteredValue.length && currentFilteredValue.type === 'removal') {
        curtotalfilteredValue.forEach(element => {

          currentResponsedata = currentResponsedata.filter(a => a.filtertype.toLowerCase() != element.toLowerCase());
          let datatobeadded = existingdata.filter(a => a.filtertype.toLowerCase() === element.toLowerCase())
          datatobeadded.forEach(element => {
            currentResponsedata.push(element);
          });
        })
        filtersMasterData = currentResponsedata;
      }

      //Sequential Filters & During Saved Filters
      else {
        curtotalfilteredValue.forEach(element => {

          if (existingdata && existingdata.length > 0) {
            currentResponsedata = currentResponsedata.filter(a => a.filtertype.toLowerCase() != element.toLowerCase());
            let datatobeadded = existingdata.filter(a => a.filtertype.toLowerCase() === element.toLowerCase())
            datatobeadded.forEach(element => {
              currentResponsedata.push(element);
            });
          }
        });

        filtersMasterData = currentResponsedata;
      }

    return filtersMasterData
  }
  findDifferenceValues(filterordercolumnname, currentFilteredValue, filter) {

    let totalfilteredValue;
    let difference;
    let indexofcurrentvaluefromlist = filterordercolumnname.indexOf(currentFilteredValue.column)
    if (indexofcurrentvaluefromlist != filterordercolumnname.length - 1) {
      let c = filterordercolumnname.slice(0, indexofcurrentvaluefromlist + 1)
      totalfilteredValue = Object.keys(filter);
      difference = totalfilteredValue.filter(x => !c.includes(x.toUpperCase()));
    }
    return difference;

  }
  addToSearchList(searchedValues, event, column) {
    let searchedVal;
    const colname = column;
    searchedVal = [event];
    if (searchedVal) {
      searchedVal = typeof searchedVal === 'string' ? searchedVal : searchedVal.join(',');
      const filteredKeyPair = {};
      filteredKeyPair[colname] = searchedVal;
      searchedValues.push(filteredKeyPair);
    }
    return searchedValues;
  }

}

export class NumericFieldFilters {
  columnname: string;
  action: string;
  value1: string;
  value2: string;
}